import { render, staticRenderFns } from "./TableConfigModal.vue?vue&type=template&id=b5df3af2&scoped=true&"
import script from "./TableConfigModal.vue?vue&type=script&lang=js&"
export * from "./TableConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./TableConfigModal.vue?vue&type=style&index=0&id=b5df3af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5df3af2",
  null
  
)

export default component.exports